// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1VaJC","bigColWidth":"Table_bigColWidth__1bt0o","biggerColWidth":"Table_biggerColWidth__3Ko8C","row":"Table_row__1nzGz","col":"Table_col__2tJHo"};